/* src/app/components/pages/flickity/flickity.component.scss */
* {
  box-sizing: border-box;
}
body {
  font-family: sans-serif;
}
.carousel-main {
  text-align: center;
  margin-top: -50px;
}
.carousel-cell {
  width: 100%;
  margin-right: 10px;
  margin-top: 10px;
  background: rgb(228, 228, 228);
  border-radius: 5px;
  counter-increment: carousel-cell;
  background-size: cover;
  overflow: hidden;
}
.carousel-cell:before {
  display: block;
  text-align: center;
  line-height: 200px;
  background-size: cover;
  font-size: 80px;
  color: white;
}
.carousel-nav .carousel-cell {
  width: 80px;
  max-height: 80px;
}
@media (min-width: 300px) and (max-width: 476px) {
  .carousel-nav .carousel-cell {
    width: 50px;
  }
}
@media (min-width: 100px) and (max-width: 300px) {
  .carousel-nav .carousel-cell {
    width: 40px;
  }
}
.carousel-nav .carousel-cell:before {
  font-size: 50px;
  line-height: 80px;
}
.carousel-nav .carousel-cell.is-nav-selected {
  background-size: cover;
  border: 1px solid black;
}
.carousel-nav .flickity-button {
  display: none !important;
}
.flickity-enabled {
  position: relative;
}
.flickity-enabled:focus {
  outline: none;
}
.flickity-viewport {
  overflow: hidden;
  position: relative;
  height: 100%;
}
.flickity-slider {
  position: absolute;
  width: 100%;
  height: 100%;
}
.flickity-enabled.is-draggable {
  -webkit-tap-highlight-color: transparent;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.flickity-enabled.is-draggable .flickity-viewport {
  cursor: move;
  cursor: -webkit-grab;
  cursor: grab;
}
.flickity-enabled.is-draggable .flickity-viewport.is-pointer-down {
  cursor: -webkit-grabbing;
  cursor: grabbing;
}
.flickity-button {
  position: absolute;
  background: hsla(0, 0%, 100%, 0.75);
  border: none;
  color: #333;
  height: 100px;
  width: 100px;
  margin-left: 40%;
  margin-right: 3%;
}
.flickity-button:hover {
  background: white;
  cursor: pointer;
}
.flickity-button:focus {
  outline: none;
  box-shadow: 0 0 0 5px #19f;
}
.flickity-button:active {
  opacity: 0.6;
}
.flickity-button:disabled {
  opacity: 0.3;
  cursor: auto;
  pointer-events: none;
}
.flickity-button-icon {
  fill: currentColor;
}
.flickity-prev-next-button {
  top: 50%;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  transform: translateY(-50%);
}
.flickity-prev-next-button.previous {
  left: 10px;
}
.flickity-prev-next-button.next {
  right: 10px;
}
.flickity-rtl .flickity-prev-next-button.previous {
  left: auto;
  right: 10px;
}
.flickity-rtl .flickity-prev-next-button.next {
  right: auto;
  left: 10px;
}
.flickity-prev-next-button .flickity-button-icon {
  position: absolute;
  left: 20%;
  top: 20%;
  width: 60%;
  height: 60%;
}
.center {
  width: 50%;
  overflow: hidden;
}
.flickity-button {
  height: 100px;
  width: 100px;
}
.material-icons.color_white {
  color: #ffffff;
}
.close-button {
  float: right;
  top: -24px;
  right: -24px;
}
.close-icon {
  transition: 1s ease-in-out;
}
.close-icon:hover {
  transform: rotate(180deg);
}
::ng-deep .slider-dialog .mat-mdc-dialog-container {
  width: 1050px !important;
  height: 90vh !important;
  overflow: hidden;
  background: transparent !important;
  box-shadow: none !important;
  padding: 12px !important;
}
::ng-deep .slider-dialog .mat-mdc-dialog-content {
  margin: 0px;
  padding: 0px;
}
::ng-deep .cdk-overlay-pane {
  max-width: 100% !important;
}
.m-t-70 {
  margin-top: 70px;
}
/*! Flickity v2.2.2
https://flickity.metafizzy.co
---------------------------------------------- */
/*# sourceMappingURL=flickity.component.css.map */
